import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {withRouter} from "react-router-dom";
import {multipleImageList} from "../../../../actions/feedAction";
import Lightbox from '../lib';

//const App = (props) => (
class App extends Component {
 
  constructor(props) {
   
   super(props);
    this.state = {
      modalIsOpen   : true,
      selectedIndex : props.currentActiveImage,
      imageList     : []
    };
    this.fetchImagelist = this.fetchImagelist.bind(this);
  }

  componentDidMount(){
   // this.fetchImagelist();
  }

  fetchImagelist(){
    let param = {
      feedId : this.props.carousalFeed,
      flag   : ((window.location.href.includes('album') == true) || (window.location.href.includes('album_edit') == true)) ? 'Album' : ''
    };
    this.props.multipleImageList(param)
  }

  UNSAFE_componentWillReceiveProps(nextProps){
    
    if(nextProps.imagelist != this.props.imagelist){
      this.setState({
        imageList : nextProps.imagelist
      })
    }
  }
 render(){
    return(
      <div> 
        <Lightbox 
          images             = {this.props.media_details}
          post_my_reaction   = {this.props.post_my_reaction}
          post_total_reaction= {this.props.post_total_reaction}
          post_total_comment = {this.props.post_total_comment}
          post_total_share   = {this.props.post_total_share}
          position           = {this.props.position}
          
        />
      </div>
    );
 }
 

}


const mapStateToProps = state => {
  return {
    imagecarousal  : state.imagecarousal.imageCarousal,
    imagelist      : state.imagelist.imageList 
  }
}
const mapDispatchToProps = dispatch => {
  return {
    multipleImageList : bindActionCreators(multipleImageList, dispatch),
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(App);

